export default function returnCreatedTimeStamp(creationDate) {
    const units = [
        { label: 'month', ms: 30 * 24 * 60 * 60 * 1000 },
        { label: 'week', ms: 7 * 24 * 60 * 60 * 1000 },
        { label: 'day', ms: 24 * 60 * 60 * 1000 },
        { label: 'hr', ms: 60 * 60 * 1000 },
        { label: 'min', ms: 60 * 1000 },
        { label: 'second', ms: 1000 }
    ];
  
    const now = new Date().getTime();
    const delta = now - new Date(creationDate).getTime();
    let result = { displayString: "just now", justPosted: delta < units[2].ms };
  
    for (let { label, ms } of units) {
        const value = Math.floor(delta / ms);
        if (value >= 1) {
            result.displayString = `${value} ${label}${value > 1 ? 's' : ''} ago`;
            break;
        }
    }
  
    return result;
}